import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { ThemeAudit } from "@/features/admin/components/theme-audit";
import { PageContainer } from "@/components/ui/page-container";

function AdminThemeAuditPage() {
  return (
    <PageContainer maxWidth="6xl">
      <ThemeAudit />
    </PageContainer>
  );
}

export const adminThemeAuditRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/theme-audit",
  component: AdminThemeAuditPage,
});
